import axios from "axios";
import url1 from "../../config.js";
const url = `${url1.url}/api/question`;

export default class Question {
    constructor(question = {}) {
        this.questionType = question.questionType || 2;
        this.questionId = question.questionId || "";
        //this.questionTitle=question.questionTitle||"";
        //this.questionDescription=question.questionDescription||"",
        //this.questionImage = question.questionImage || null,
        (this.questionAudio = question.questionAudio || ""),
            (this.questionStatus = question.questionStatus || true),
            (this.questionOptions = question.questionOptions || []),
            (this.questionAnswers = question.questionAnswers || []),
            (this.questionStatement = question.questionStatement || ""),
            (this.questionKeySequence = question.questionKeySequence || []),
            (this.questionKeySequenceAudio =
                question.questionKeySequenceAudio || "");
    }

    // static get = async (token) => {
    //     return axios.get(`${url}`, {headers:{"x-auth-token":token}});}

    static getQuestionInfo = async (question_id, questionType, token) => {
        console.log("questioninfo question_id", question_id);
        return axios.get(`${url}/questioninfo/${question_id}/${questionType}`, {
            headers: { "x-auth-token": token }
        });
    };

    //api to get course count in Dashboard.vue page
    // static getQuestionCount = async (token) => {
    //     console.log('get question count client')
    //     return  axios.get(`${url}/questioncount`, {headers:{"x-auth-token":token}});
    // }

    // static getCountCourse = async (token) => {
    //     return  axios.get(`${url}/coursecount`, {headers:{"x-auth-token":token}});
    // }

    static postQuestion(token, formData) {
        console.log("client post question", formData);
        return axios.post(`${url}/newquestiontypetwo`, formData, {
            headers: { "x-auth-token": token }
        });
    }

    static putQuestion(question_id, formData, token) {
        return axios.put(
            `${url}/updatequestiontypetwo/${question_id}`,
            formData,
            { headers: { "x-auth-token": token } }
        );
    }
}
